<template>
    <div class="table_wrap">
        <el-table :data="boardData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  @selection-change="tableSelectChange"
                  height="695"
        >
           <!-- <el-table-column
                    type="selection"
                    class-name="text-center"
                    min-width="25">
            </el-table-column>-->
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    min-width="45"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
            <el-table-column label="작성자" width="300" prop="Writer.mb_nick" class-name="text-center"></el-table-column>
            <el-table-column label="작성일자" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDateUnix(scope.row.created_at, 'YYYY-MM-DD HH:mm')}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="옵션" width="100" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goDetail(scope.row.wr_id)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import dateMixins from "@/mixins/dateMixins";
    export default {
        name: "BoardListUserContentLayout",
        mixins: [dateMixins],
        components: {},
        inject: {
            setPage: {
                default: () => {
                }
            },
            boardListSetData: {
                default: () => {
                }
            },
            setFilter: {
                default: () => {
                }
            },
        },
        provide() {
            return {}
        },
        props: {
            boardType: '',
            boardData: {
                default: () => {
                    return []
                }
            },
            paginationData: {
                default: () => {
                    return {total: 0, page: 0, size: 0,}
                }
            },
        },
        data() {
            return {}
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
            tableSelectChange(row) {
                this.selectArr = [];
                util.Array.each(row, (obj, index, arr) => {
                    this.selectArr.push(obj.wr_id);
                });
                this.boardListSetData('selectArr', this.selectArr)
            },
            returnDate(date = null) {
                if (!date) {
                    return '';
                }
                return this.$moment(date).format('YYYY-MM-DD HH:mm')
            },
            goDetail(key) {
                this.$router.push(`${this.$route.path}/${key}`);

            },
            runDelete() {

            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
